import { ISemanticEvent } from '@cp/shared/tracking';
import { useEffect } from 'react';
import { useTrackEvent } from './useTracking';

const scheduleRun = (callback: () => void, signal: AbortSignal) => {
  const run = () => signal.aborted || callback();
  // https://developer.mozilla.org/en-US/docs/Web/API/Window/requestIdleCallback#browser_compatibility
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(run);
  } else {
    setTimeout(run, 500);
  }
};

/**
 * Fire tracking event on component mount
 */
export const useTrackMount = (eventFactory: () => ISemanticEvent) => {
  const track = useTrackEvent();
  useEffect(() => {
    const controller = new AbortController();
    scheduleRun(() => track(eventFactory()), controller.signal);

    return () => controller.abort();
  }, [track, eventFactory]);
};
